import { getBrandConfig } from "./brandConfig";

export function getRuntimeBrand() {
  return getBrandConfig();
}
